import { reducer as form } from 'redux-form';
import {
  userAwarenessReducer as userAwareness,
  toastsReducer as toasts,
} from '@zola-helpers/client';
import type { Action } from 'redux';
import type { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { UserContext } from 'actions/UserActions';
import photobooks from '../photobooks/reducers';
import onboard from './onboard';
import website from './website';
import wedding, { WeddingReducerStateType } from './wedding';
import modal from './modal';
import auth from './auth';
import guestList, { GuestListReducerStateType } from './guestList';
import user from './user';
import checklist, { ChecklistReducerStateType } from './checklist';
import publicWebsite from './public';
import collectAddress from './collectAddress';
import dashboard from './dashboard';
import moduleGroup from './moduleGroup';
import registry from './registry';
import registryCollections from './registryCollections';
import cart from './cart';
import feed from './feed';
import external from './external';
import cache from './cache';
import events, { EventsReducerStateType } from './events';
import cards from '../cards/reducers';
import cashSettings from './cashSettings';
import seatingChart from './seatingChart';
import guestRail from './guestRail';
import registryBulkImport from './registryBulkImport';
import shop from './shop';
import uploadcare from './uploadcare';
import userExperiment from './userExperiment';
import zoom, { ZoomReducerStateType } from './zoom';

export type RootState = {
  checklist: ChecklistReducerStateType;
  events: EventsReducerStateType;
  guestList: GuestListReducerStateType;
  zoom: ZoomReducerStateType;
  wedding: WeddingReducerStateType;
  toasts: unknown[];
  user: {
    userContext: UserContext;
    hasIdentified: boolean;
    hasGuestIdentified: boolean;
    partnerContext: { userObjectId: string; partnerUserObjectId: string; status: string }[];
  };
};

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type AppDispatch = ThunkDispatch<RootState, unknown, Action<string>>;

export default {
  auth,
  cache,
  cards,
  cart,
  cashSettings,
  checklist,
  collectAddress,
  dashboard,
  events,
  external,
  feed,
  form,
  guestList,
  guestRail,
  modal,
  moduleGroup,
  Onboard: onboard,
  publicWebsite,
  registry,
  registryBulkImport,
  registryCollections,
  seatingChart,
  shop,
  toasts,
  uploadcare,
  user,
  userAwareness,
  userExperiment,
  website,
  wedding,
  zoom,
  photobooks,
};



// WEBPACK FOOTER //
// ./src/reducers/index.ts